import VendorAnalytics from '@decorators/vendorAnalytics';
import { useCallback } from 'react';
import type { Track } from 'types/analytics';
import AnalyticsConstants from '../../../../../../../../constants/analytics';

const TRACKING_BOOK_VENDOR_PARAMS = {
	reason: 'couples_mark_as_booked',
	build_product: 'marketplace',
	source_page: 'storefront',
	source_content: 'mark as booked modal',
};

export const useTrackBookVendor = (
	track: Track,
	vendorHired: boolean,
	vendor: Vendor.Decorated,
) => {
	return useCallback(
		(vendorFoundOnTk?: string) => {
			const vendorAnalytics = new VendorAnalytics(vendor);

			track({
				event: AnalyticsConstants.VENDOR_MARK_AS_BOOKED,
				properties: {
					vendorHired,
					...(vendorFoundOnTk && {
						vendorFoundOnTK: vendorFoundOnTk,
					}),
					...TRACKING_BOOK_VENDOR_PARAMS,
					...vendorAnalytics.baseEventProps(),
				},
			});
		},
		[track, vendorHired, vendor],
	);
};
